"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDarkTheme = isDarkTheme;
exports.isLightTheme = isLightTheme;
exports.themeModeStyle = themeModeStyle;

var _theme = require("./theme.types");

function isDarkTheme(props) {
  return props.theme.mode === _theme.ThemeMode.dark;
}

function isLightTheme(props) {
  return props.theme.mode === _theme.ThemeMode.light;
}

function themeModeStyle(darkStyle, lightStyle) {
  return props => {
    const style = isLightTheme(props) ? lightStyle : darkStyle;

    switch (typeof style) {
      case 'function':
        return style(props);

      default:
        return style;
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJpc0RhcmtUaGVtZSIsInByb3BzIiwidGhlbWUiLCJtb2RlIiwiVGhlbWVNb2RlIiwiZGFyayIsImlzTGlnaHRUaGVtZSIsImxpZ2h0IiwidGhlbWVNb2RlU3R5bGUiLCJkYXJrU3R5bGUiLCJsaWdodFN0eWxlIiwic3R5bGUiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvdGhlbWUudXRpbHMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ1NTUHJvcCwgRGVmYXVsdFRoZW1lIH0gZnJvbSAnc3R5bGVkLWNvbXBvbmVudHMnXG5pbXBvcnQgeyBUaGVtZU1vZGUsIFRoZW1lU3R5bGVHZXR0ZXIsIFRoZW1lZENvbXBvbmVudFByb3BzIH0gZnJvbSAnLi90aGVtZS50eXBlcydcblxuZXhwb3J0IGZ1bmN0aW9uIGlzRGFya1RoZW1lKHByb3BzOiBUaGVtZWRDb21wb25lbnRQcm9wcyk6IGJvb2xlYW4ge1xuICByZXR1cm4gcHJvcHMudGhlbWUubW9kZSA9PT0gVGhlbWVNb2RlLmRhcmtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGlzTGlnaHRUaGVtZShwcm9wczogVGhlbWVkQ29tcG9uZW50UHJvcHMpOiBib29sZWFuIHtcbiAgcmV0dXJuIHByb3BzLnRoZW1lLm1vZGUgPT09IFRoZW1lTW9kZS5saWdodFxufVxuXG5leHBvcnQgZnVuY3Rpb24gdGhlbWVNb2RlU3R5bGUoZGFya1N0eWxlOiBDU1NQcm9wPERlZmF1bHRUaGVtZT4gfCBUaGVtZVN0eWxlR2V0dGVyLCBsaWdodFN0eWxlOiBDU1NQcm9wPERlZmF1bHRUaGVtZT4gfCBUaGVtZVN0eWxlR2V0dGVyKSB7XG4gIHJldHVybiAocHJvcHM6IFRoZW1lZENvbXBvbmVudFByb3BzKSA9PiB7XG4gICAgY29uc3Qgc3R5bGUgPSBpc0xpZ2h0VGhlbWUocHJvcHMpID8gbGlnaHRTdHlsZSA6IGRhcmtTdHlsZVxuXG4gICAgc3dpdGNoICh0eXBlb2Ygc3R5bGUpIHtcbiAgICAgIGNhc2UgJ2Z1bmN0aW9uJzpcbiAgICAgICAgcmV0dXJuIHN0eWxlKHByb3BzKVxuICAgICAgZGVmYXVsdDpcbiAgICAgICAgcmV0dXJuIHN0eWxlXG4gICAgfVxuICB9XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUNBOztBQUVPLFNBQVNBLFdBQVQsQ0FBcUJDLEtBQXJCLEVBQTJEO0VBQ2hFLE9BQU9BLEtBQUssQ0FBQ0MsS0FBTixDQUFZQyxJQUFaLEtBQXFCQyxnQkFBQSxDQUFVQyxJQUF0QztBQUNEOztBQUVNLFNBQVNDLFlBQVQsQ0FBc0JMLEtBQXRCLEVBQTREO0VBQ2pFLE9BQU9BLEtBQUssQ0FBQ0MsS0FBTixDQUFZQyxJQUFaLEtBQXFCQyxnQkFBQSxDQUFVRyxLQUF0QztBQUNEOztBQUVNLFNBQVNDLGNBQVQsQ0FBd0JDLFNBQXhCLEVBQTZFQyxVQUE3RSxFQUFtSTtFQUN4SSxPQUFRVCxLQUFELElBQWlDO0lBQ3RDLE1BQU1VLEtBQUssR0FBR0wsWUFBWSxDQUFDTCxLQUFELENBQVosR0FBc0JTLFVBQXRCLEdBQW1DRCxTQUFqRDs7SUFFQSxRQUFRLE9BQU9FLEtBQWY7TUFDRSxLQUFLLFVBQUw7UUFDRSxPQUFPQSxLQUFLLENBQUNWLEtBQUQsQ0FBWjs7TUFDRjtRQUNFLE9BQU9VLEtBQVA7SUFKSjtFQU1ELENBVEQ7QUFVRCJ9